<!-- Gauge Settings -->
@if (isGaugeWidget) {
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <scitis-widget-configuration-signals-selector
          (signalSelectionChanged)="onSignalSelect($event)"
          [items]="allUsableSignals"
          [multiSelection]="false"
          [selectedSignalsIds]="selectedSignalId"
          [showColor]="false"
          [validate]="true">
        </scitis-widget-configuration-signals-selector>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <span class="form-label" translate>Design</span>
          <div class="btn-group d-flex btn-group-toggle" name="radioBasic"
            ngbRadioGroup>
            <label [class.active]="isModernGauge" class="btn btn-outline-primary w-50"
              ngbButtonLabel>
              <input (click)="selectModernGaugeStyle()" ngbButton
                type="radio">
                <span translate>Modern</span>
              </label>
              <label [class.active]="isClassicGauge" class="btn btn-outline-primary w-50"
                ngbButtonLabel>
                <input (click)="selectClassicGaugeStyle()" ngbButton
                  type="radio">
                  <span translate>Classic</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <scitis-signal-slices-configuration [signal]="userDefinedWidget.userDefinedChartDetails.signals[0]"
          [widgetType]="userDefinedWidget.widgetDetails.widgetType">
        </scitis-signal-slices-configuration>
        @if (hasDeletedSignals()) {
          <div class="d-flex align-items-center justify-content-center mb-0 mt-2 alert alert-warning text-center">
            <em class="fa-solid fa-circle-exclamation mr-2"></em>
            <span translate>Selected Signal has been deleted in the asset configuration. Please select a new one.</span>
          </div>
        }
      </div>
    }

